import { createStyles } from '@material-ui/core/styles';

import { colours } from '@shared/theme/colours';

export const styles = () =>
  createStyles({
    root: {
      alignItems: 'center',
      backgroundColor: colours.solid.white,
      bottom: 0,
      display: 'flex',
      justifyContent: 'center',
      left: 0,
      position: 'fixed',
      right: 0,
      top: 0,
      zIndex: 10001,
    },
  });
